import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { TextHeadline3, Link, Card } from 'blocket-ui'

import { GalleryItem } from './GalleryItem'

const mapStateToProps = (state) => ({
  gallery: state.classified.searchResults.gallery,
})

const Wrapper = styled(Card)`
  padding: 16px;
  margin-bottom: 16px;
`

export const StyledLink = styled(Link)`
  display: block;
  margin-top: 16px;
`

export const Gallery = ({ gallery = [] }) => {
  if (gallery.length <= 0) {
    return null
  }

  return (
    <Wrapper tagName="aside">
      <TextHeadline3 tagName="span">Galleriet</TextHeadline3>
      {gallery.map((ad) => (
        <GalleryItem key={ad.adId} ad={ad} />
      ))}
      <StyledLink external to="/tjanster/galleriet">
        Om galleriet
      </StyledLink>
    </Wrapper>
  )
}

Gallery.propTypes = {
  gallery: PropTypes.array,
}

export default connect(
  mapStateToProps,
  null,
)(Gallery)
